import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'convertSecondsToDate'
})
export class ConvertSecondsToDatePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        let hours = Math.floor(value / 3600).toString().padStart(2, '0');
        let minutes = Math.floor(value / 60 % 60).toString().padStart(2, '0');
        let seconds = Math.floor(value % 60).toString().padStart(2, '0');
        return hours + ':' + minutes + ':' + seconds;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/pipe/convert-seconds-to-date.pipe.ts